export const endpoint = {
  riskReport: 'riskReport',
  drilldown: (id: number) =>  `riskReport/${id}/drilldown`,
  report: 'report',
  reportCategory: 'report/options'
};

export enum RiskMatrixTypes {
  Type3 = 3,
  Type4 = 4
}

export const riskReportTranslation = {
  risk_matrix_not_supported: 9279,
  attribute_show_loss_potential: 9298,
  attribute_show_residual_loss_potential: 9299,
  attribute_xAxis_labels_enabled: 8030,
  attribute_yAxis_labels_enabled: 8029,
  attribute_show_case_numbers: 9328,
  toggle_info_description: 7759,
  toggle_info_subtitle: 7760,
  toggle_info_title: 7761,
  search_no_hits: 7548,
  search_hits: 7474,
  warning_select_residual_or_loss_potential: 9301,
  drill_down_to_info: 9314,
  done: 7338,
  case_number_list_limited_to: 9334
};

export const defaultMaxCaseNumbers = 100;
export const rowHeightForShowCaseNumbersEnabled = 97;

export const RiskReportLayoutAttributes = {
  MaxCaseNumbersInPopup: 'RiskReport.maxCaseNumbersInPopup'
};

export const RiskMatrixCellProperties = {
  MinCellWidth: 80,
  CaseCountHeight: 36,
  CaseNumberLineHeight: 26,
  MarginBottom: 4,
  MaxCasesPerCell: 10,
  DefaultChartSpacingRight: 10
};
